import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=14d7c830"
import script from "./Patients.vue?vue&type=script&lang=ts"
export * from "./Patients.vue?vue&type=script&lang=ts"
import style0 from "./Patients.vue?vue&type=style&index=0&id=14d7c830&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports